import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PermissionsService } from "Bands/services";

const queryKey = ["editPermissions"];

export const useEditPermissions = () => {
  const queryClient = useQueryClient();

  const editPermissionsQuery = useMutation({
    mutationFn: ({
      userId,
      data,
    }: {
      userId: string;
      data: { permissions: { permission: string; granted: boolean }[] };
    }) => PermissionsService.editUserPermissions(userId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    editPermissionsQuery,
  };
};
